import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import authService from "../services/authService";
export default function AdminLogin() {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); 
  const [showPassword, setShowPassword] = useState(false);
 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    await authService.adminLogin({
      email: login,
      password: password,
    });

    toast.success("Admin logged in successfully!");
    navigate("/admin/dashboard", { replace: true });

  } catch (err) {
    console.error("Admin Login Error:", err.response?.data || err);
    toast.error(
      err.response?.data?.detail?.[0]?.msg || "Invalid credentials"
    );
  } finally {
    setLoading(false);
  }
};
  return (
    <div className="container-xxl">
      <div className="authentication-wrapper authentication-basic container-p-y">
        <div className="authentication-inner">
          <div className="card">
            <div className="card-body">
              <div className="app-brand justify-content-center mb-3">
                <Link to="/" className="app-brand-link gap-2">
                  <img src="/gdmartlogo.svg" alt="Logo" />
                </Link>
              </div>
              <h4 className="mb-4 text-center">Admin Panel 👋</h4>
              <p className="mb-4 text-center">Please sign-in to your admin account</p>
              <form onSubmit={handleSubmit} className="mb-3">
              
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    value={login}
                    onChange={(e) => setLogin(e.target.value)}
                    className="form-control"
                    placeholder="Enter email"
                    required
                  />
                </div>
            
<div className="mb-3">
  <div className="d-flex justify-content-between">
    <label className="form-label">Password</label>
    <Link to="/forgot-password">
      <small style={{color:"#3b82f6"}}>Forgot Password?</small>
    </Link>
  </div>
  <div className="input-group">
    <input
      type={showPassword ? "text" : "password"}
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      className="form-control"
      placeholder="••••••••"
      required
    />
    <span
      className="input-group-text cursor-pointer"
      onClick={() => setShowPassword(prev => !prev)}
    >
      <i className={showPassword ? "bx bx-show" : "bx bx-hide"} />
    </span>
  </div>
</div>
                <button
                  type="submit"
                  className="btn  d-grid w-100"
                  disabled={loading}  
                    style={{ backgroundColor: "#3b82f6", borderColor: "#3b82f6", color: "#fff" }}
                >
                  {loading ? "Signing in..." : "Admin Sign in"}
                </button>
              </form>
              <p className="text-center mt-2">
                <Link to="/login" style={{color:"#3b82f6"}}>Back to User Login</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
